import {action, computed} from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsBell } from '@react-icons/all-files/bs/BsBell';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { toArray } from '../Utils/Array';
import { autoinject, inject } from '../Utils/AutoInject';
import { IDisposable } from '../Utils/Mixins';
import { isUserTask, TasksStore } from '../Utils/TasksStore';
import { NotificationItem } from './NotificationItem';
import {bind} from "../Utils/Bind";

@autoinject
@observer
export class NotificationList extends React.Component {
    public async componentDidMount() {
        try {
            this.handle = await this.tasksStore.connectionManager.connect();

            await this.tasksStore.loadUserTasksAsync();
        } catch (e: any) {
            console.error('Failed to connect to Tasks Store', e);
        }
    }

    public componentWillUnmount() {
        this.handle?.dispose();
    }

    public render() {
        return (
            <UncontrolledButtonDropdown className="notification-button" onClick={this.handleClick}>
                <DropdownToggle
                    color="link"
                    className="btn btn-link notification-icon"
                    onClick={this.tasksStore.dismissAllToasts}
                >
                    <BsBell />

                    {this.running && (
                        <div className="notification-progress-bar">
                            <div />
                        </div>
                    )}

                    {!!this.tasksStore.tasks.size && (
                        <div className="notification-counter">{this.tasksStore.tasks.size}</div>
                    )}
                </DropdownToggle>
                <DropdownMenu className="notification-bar py-0 bg-white">
                    {!!this.tasksStore.tasks.size && (
                        <div className="w-100 text-primary d-flex">
                            <a className="btn-sm me-auto" onClick={this.tasksStore.clearAll}>
                                Clear All
                            </a>
                        </div>
                    )}

                    {!this.tasksStore.tasks.size && (
                        <DropdownItem className="notification-item text-center rounded-0">
                            No Notifications
                        </DropdownItem>
                    )}
                  <div className="overflow-y-600">
                      {toArray(this.tasksStore.tasks).map(t => (
                          <NotificationItem key={isUserTask(t) ? t.userTaskGuid : t.sessionTaskGuid} task={t} />
                      ))}
                  </div>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }
    
    @bind
    @action
    private handleClick() {
        this.tasksStore.dismissAllToasts();
    }

    @computed
    private get running() {
        return !!toArray(this.tasksStore.tasks).find(t => t.state == Mri.UserTasks.UserTaskState.Running);
    }

    private handle?: IDisposable;
    @inject
    private readonly tasksStore!: TasksStore;
}
